import React from 'react';
import { useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ScrollWrapper, TableWrapper } from './styles';
import { useRef } from 'react';
const HEADER_HEIGHT = 30;
const ROW_HEIGHT = 24;
function HistoryTable({ data, handleTableRef }) {
	const gridRef = useRef();
	const [columnDefs] = useState([
		{
			field: 'action_Performed_By',
			headerName: 'Enity Name',
			resizable: true,
			sortable: true,
			width: 230,
		},
		{
			field: 'action_Type',
			headerName: 'Action Level',
			resizable: true,
			sortable: true,
			width: 230,
		},
		{
			field: 'action_Performed',
			headerName: 'Action',
			resizable: true,
			sortable: true,
			width: 230,
		},
		{
			field: 'action_Performed_DateTime',
			headerName: 'Action Performed at',
			resizable: true,
			sortable: true,
			cellDataType: 'date',
			width: 230,
		},
	]);
	const getGridOptions = () => {
		return {
			defaultColDef: {
				suppressMenu: true,
			},
			rowData: data.map(d => {
				return {
					...d,
					action_Performed_DateTime: new Date(
						d.action_Performed_DateTime
					).toString(),
				};
			}),
			rowHeight: ROW_HEIGHT,
			headerHeight: HEADER_HEIGHT,
			columnDefs,
			suppressRowHoverHighlight: true,
			suppressRowDrag: true,
			suppressRowClickSelection: true,
			suppressCellSelection: true,
			suppressContextMenu: true,
			suppressMultiSort: true,
			domLayout: 'autoHeight',
		};
	};

	return (
		<TableWrapper>
			<ScrollWrapper>
				<div className="ag-theme-balham">
					<AgGridReact {...getGridOptions()} ref={gridRef} />
				</div>
			</ScrollWrapper>
		</TableWrapper>
	);
}

export default HistoryTable;
